import { useAuth0 } from '@auth0/auth0-react';
import { Box, Grid, Typography } from '@mui/material';
import citiLogo from 'Assets/CitiBot.png';
import loginBg from 'Assets/hero.png';
import Button from 'Components/Button';
import Form from 'Components/Forms/Form';
// import FormInput from 'Components/Forms/FormInput';
// import FormPasswordInput from 'Components/Forms/FormPasswordInput';
import useAuth from 'Hooks/useAuth';
import { FormikHelpers } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { ILoginForm } from 'redux/auth/authApiSlice';
import * as yup from 'yup';

const initialValues = {
  username: '',
  password: ''
};

const validationSchema = yup.object({
  username: yup.string().required().label('UserName'),
  password: yup.string().required().label('Password')
});

const Login = () => {
  const { loginLoading, isLoggedIn } = useAuth();
  const {
    // loginWithPopup,
    loginWithRedirect
  } = useAuth0();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const handleNavigation = () => {
    navigate(from, { replace: true });
  };

  const handleSubmit = async (values: ILoginForm, { setSubmitting }: FormikHelpers<ILoginForm>) => {
    // await login(values);
    handleNavigation();
    setSubmitting(false);
  };
  if (isLoggedIn) {
    console.log('isLoggedIn');
  }
  return (
    <Grid container data-testid="LoginPage" sx={{ height: '100vh' }}>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${loginBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '70%',
          backgroundPosition: 'center'
        }}
      />
      <Grid item xs={12} sm={8} md={5}>
        <Box
          component="div"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            px: '15px',
            height: '100vh'
          }}
        >
          <Grid container maxWidth="25em">
            <Box
              component="img"
              sx={{
                width: '50%'
              }}
              src={citiLogo}
              alt="hero"
            />
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ mb: 2, mt: 5, fontWeight: 500 }}>
                Welcome to CITIBOT CMS
              </Typography>
            </Grid>
            <Form
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              {/* <Grid item xs={12}>
                <FormInput id="username" label="Username" />
              </Grid>
              <Grid item xs={12} sx={{mt: 1}}>
                <FormPasswordInput id="password" label="Password" />
              </Grid> */}
              <Grid container item xs={12}>
                <Button
                  variant="contained"
                  sx={{ mt: 2, mb: 4, borderRadius: 6, px: 8, fontWeight: 500, color: '#fff' }}
                  isLoading={loginLoading}
                  color="secondary"
                  onClick={() => loginWithRedirect()}
                >
                  Login
                </Button>
              </Grid>
            </Form>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
